import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { Style } from '@react-pdf/types';

const MAIN_COLOR = '#00356B';
const BORDER = `1 solid ${MAIN_COLOR}`;

const cellMixin: Style = {
	height: 18,
	backgroundColor: 'white',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	color: MAIN_COLOR,
};

const styles = StyleSheet.create({
	container: {
		backgroundColor: 'white',
	},
	title: {
		fontSize: 14,
		marginBottom: 8,
	},
	row: {
		display: 'flex',
		flexDirection: 'row',
		width: '100%',
		borderBottom: BORDER,
		backgroundColor: 'white',
	},
	cell: {
		...cellMixin,
	},
});

interface Props<ColID extends string> {
	title?: string;
	columns: Array<{
		id: ColID;
		name: string;
	}>;
	data: Array<{
		item: Record<ColID, string>;
		meta?: {
			isBorderDisabled?: boolean;
		};
	}>;
}

export const TablePDF = <ColID extends string>(props: Props<ColID>) => {
	const {
		title, //
		columns,
		data,
	} = props;

	const rowsCount = data.length + 1;

	const renderRows = () => {
		const rows = [];

		for (let i = 0; i < rowsCount; i++) {
			const dataItem = data[i - 1];
			const noBorder = dataItem?.meta?.isBorderDisabled ?? false;

			const isHeadingRow = i === 0;

			rows.push(
				<View style={{ ...styles.row, ...(noBorder && { borderBottom: 'none' }) }}>
					{columns.map(({ id, name }) => (
						<View
							key={id}
							style={{
								...styles.cell,
								width: 100 / columns.length + '%',
							}}
						>
							<Text style={{ fontWeight: isHeadingRow ? '600' : '400' }}>{isHeadingRow ? name : dataItem.item[id]}</Text>
						</View>
					))}
				</View>,
			);
		}

		return rows;
	};

	return (
		<View>
			{title && <Text style={styles.title}>{title}</Text>}
			<View style={styles.container}>{renderRows()}</View>
		</View>
	);
};
